import classNames from 'classnames';
import { IconCheck } from 'featherico';
import type * as React from 'react';
import type { ReactNode } from 'react';
import type { ButtonKind, ButtonProps } from '../Button';
import Button from '../Button';
import LoadingIndicator from '../LoadingIndicator';
import styles from './style.m.less';

export const DISABLED: SaveButtonState = 'DISABLED';
export const ENABLED: SaveButtonState = 'ENABLED';
export const SAVING: SaveButtonState = 'SAVING';
export const SAVED: SaveButtonState = 'SAVED';

export type SaveButtonState = 'DISABLED' | 'ENABLED' | 'SAVING' | 'SAVED';
export type SaveButtonLabels = { [saveButtonState in SaveButtonState]?: ReactNode };

const DEFAULT_LABELS: SaveButtonLabels = {
    DISABLED: 'Save',
    ENABLED: 'Save',
    SAVING: 'Saving',
    SAVED: 'Saved',
};

const LABEL_PREFIXES: Record<SaveButtonState, ReactNode> = {
    DISABLED: null,
    ENABLED: null,
    SAVING: <LoadingIndicator />,
    SAVED: <IconCheck />,
};

type Props = {
    state?: keyof typeof DEFAULT_LABELS;
    labels?: SaveButtonLabels;
    disabled?: boolean;
    className?: string;
    tooltip?: string;
    tooltipOptions?: string;
} & ButtonProps;

const SaveButton: React.FC<Props> = props => {
    const {
        state = ENABLED,
        labels,
        onClick,
        className,
        kind,
        disabled,
        tooltip,
        tooltipOptions,
        type = 'submit',
        ...otherProps
    } = props;
    const mergedLabels = { ...DEFAULT_LABELS, ...labels };
    const isEnabled = state === ENABLED;
    const defaultKind: ButtonKind = isEnabled ? 'PRIMARY' : 'DEFAULT';
    const buttonProps = {
        kind: kind || defaultKind,
        disabled: !isEnabled || disabled,
        onClick: isEnabled ? onClick : undefined,
        'data-tooltip': tooltip,
        'data-tooltip-options': tooltipOptions,
        className: classNames(className, { [styles.saved]: state === SAVED }),
        type,
        ...otherProps,
    };
    return (
        <Button {...buttonProps}>
            {LABEL_PREFIXES[state]} {mergedLabels[state]}
        </Button>
    );
};

export default SaveButton;
